import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {CloningGroupNameAll, setCloningFeatureChecked} from './FabricatorsActions';
import CheckBox from "../PageLayout/CheckBox";

const FabricatorsCloneFeature = (props) => {

  const {feature, style, cloningFabFeaturesSelectedGroup, setCloningFeatureChecked} = props;

  const name = cloningFabFeaturesSelectedGroup === CloningGroupNameAll
    ? `${feature.groupName} - ${feature.featureName}`
    : feature.featureName

  const onChecked = (checked) => {
    setCloningFeatureChecked({ featureId: feature.id, checked: !checked })
  }

  return (
    <li style={style} className="fabricators-container__item fabricators-container__item--2">
      <div className="fabricators-lir">
        <div className="fabricators-col fabricators-col--no-border checkbox">
          <CheckBox checked={feature.isChecked} text={name} onChecked={onChecked}/>
        </div>
        {/*{index === 0 ? <div className="fabricators-col fabricators-col--no-border text"/> : null}*/}
        {/* why do we need that? */}
      </div>
    </li>
  )
}


FabricatorsCloneFeature.propTypes = {
  feature: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
};


const mapStateToProps = (store) => {
  const {cloningFabFeaturesSelectedGroup} = store.fabricators;
  return {
    cloningFabFeaturesSelectedGroup,
  }
};

const mapDispatchToProps = {
  setCloningFeatureChecked,
}

export default connect(mapStateToProps, mapDispatchToProps)(FabricatorsCloneFeature)


